import React, { createContext, useState } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([
    {
      productImage: 'https://via.placeholder.com/80',
      productTitle: 'Sample Product 1',
      shopName: "Sample Shop 1",
      productLink: '#',
      productAlt: 'Sample Product 1',
      categoryDetails: 'Category 1',
      price: 800000,
      quantity: 1,
      totalPrice: 800000,
      selected: false,
    },
    {
      productImage: 'https://via.placeholder.com/80',
      productTitle: 'Sample Product 2',
      shopName: "Sample Shop 2",
      productLink: '#',
      productAlt: 'Sample Product 2',
      categoryDetails: 'Category 2',
      price: 200,
      quantity: 2,
      totalPrice: 400,
      selected: false,
    }
  ]);

  const value = {
    cartItems,
    setCartItems,
  };

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};
